import React, { useRef, useState, useEffect } from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"
import { HeaderBlack } from "../components/header"
import { FooterDark } from "../components/footer"
import SEO from "../components/seo"
import "../css/hyperion.css"

import Landing from "../images/HyperionLanding.png"
import TopD from "../images/HyperionTopD.png"
import Side from "../images/HyperionSide.png"
import ArcR from "../images/HyperionArcR.png"



const getDimensions = (ele) => {
  const { height } = ele.getBoundingClientRect();
  const offsetTop = ele.offsetTop;
  const offsetBottom = offsetTop + height;

  return {
    height,
    offsetTop,
    offsetBottom,
  };
};


const scrollTo = (ele) => {
  ele.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

const Hyperion = () => {
  const [visibleSection, setVisibleSection] = useState();

  const landingRef = useRef(null);
  const aboutRef = useRef(null);
  const designRef = useRef(null);
  const mountRef = useRef(null);
  const pcbRef = useRef(null);
  const dimensionsRef = useRef(null);
  const assemblyRef = useRef(null);

  const sectionRefs = [
    { section: "Landing", ref: landingRef },
    { section: "About", ref: aboutRef },
    { section: "Case Design", ref: designRef },
    { section: "Mounting Mechanism", ref: mountRef },
    { section: "PCB", ref: pcbRef },
    { section: "Dimensions", ref: dimensionsRef },
    { section: "Assembly", ref: assemblyRef },
  ];


  useEffect(() => {
    const handleScroll = () => {
      const { height: headerHeight } = getDimensions(landingRef.current);
      const scrollPosition = window.scrollY + headerHeight;

      const selected = sectionRefs.find(({ section, ref }) => {
        const ele = ref.current;
        if (ele) {
          const { offsetBottom, offsetTop } = getDimensions(ele);
          return scrollPosition > offsetTop && scrollPosition < offsetBottom;
        } else {
          return null;
        }
      });

      if (selected && selected.section !== visibleSection) {
        setVisibleSection(selected.section);
      } else if (!selected && visibleSection) {
        setVisibleSection(undefined);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleSection]);


  function onLinkClick() {
    document.getElementById("About").scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  return (
    <div className="hyperion">
      <SEO title="Hyperion" />
      <header id="Landing" ref={landingRef}>
        <HeaderBlack />
      </header>

      <section className="hyp-landing">
        <div className="hyp-landingcontent">
          <div className="hyp-landingtext">
            <motion.h1
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0, duration: 1.25, ease: "easeOut" }}
            >
              HYPERION
            </motion.h1>
            <motion.p
              style={{ fontFamily: "TTNorms" }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.25, duration: 1.3, ease: "easeOut" }}
            >
              ditch the plate, it's time for flex.
            </motion.p>
          </div>
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 2.55, duration: 1, ease: "easeOut" }}
            width="70%"
            src={Landing}
            alt="teaser" />
        </div>

        <svg id="scrollArrow" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" onClick={onLinkClick} height="5vh" stroke="#f1f1f1" strokeWidth="5" strokeLinecap="round" fill="none">
          <polyline points="20,55 50,85 80,55"></polyline>
        </svg>
      </section>

      <div className="hyp-content">
        <nav className="hyp-navbar">
          <Link to="/" style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
            <svg className="icon1" xmlns="http://www.w3.org/2000/svg" height="60px" viewBox="0 0 402.82 454.69"><title>Horizon Icon</title><path d="M326.54,314.78H240.38a7.54,7.54,0,0,1,0-15.08h86.16a7.54,7.54,0,0,1,0,15.08Z" transform="translate(-82.05 -56.12)" /><path d="M386.86,347.1H180.07a7.54,7.54,0,1,1,0-15.08H386.86a7.54,7.54,0,0,1,0,15.08Z" transform="translate(-82.05 -56.12)" /><path d="M408.41,379.41H158.52a7.54,7.54,0,1,1,0-15.08H408.41a7.54,7.54,0,0,1,0,15.08Z" transform="translate(-82.05 -56.12)" /><path d="M361,411.72H205.91a7.54,7.54,0,1,1,0-15.08H361a7.54,7.54,0,0,1,0,15.08Z" transform="translate(-82.05 -56.12)" /><path d="M305,444H261.92a7.54,7.54,0,1,1,0-15.08H305A7.54,7.54,0,0,1,305,444Z" transform="translate(-82.05 -56.12)" /><path d="M373.94,476.35H193a7.54,7.54,0,0,1,0-15.08h181a7.54,7.54,0,0,1,0,15.08Z" transform="translate(-82.05 -56.12)" /><path d="M288.85,510.81H278.08a7.54,7.54,0,1,1,0-15.08h10.77a7.54,7.54,0,0,1,0,15.08Z" transform="translate(-82.05 -56.12)" /><path d="M408.93,250.17a7.45,7.45,0,0,1-2.56-.46,7.53,7.53,0,0,1-4.52-9.65,126,126,0,1,0-236.77,0,7.54,7.54,0,1,1-14.17,5.13,140.58,140.58,0,0,1-8.54-48c0-77.81,63.29-141.1,141.09-141.1s141.1,63.29,141.1,141.1a140.58,140.58,0,0,1-8.54,48A7.53,7.53,0,0,1,408.93,250.17Z" transform="translate(-82.05 -56.12)" /><path d="M366.66,250.17a7.44,7.44,0,0,1-3.61-.93,7.53,7.53,0,0,1-3-10.23,87.25,87.25,0,1,0-153.17,0,7.54,7.54,0,0,1-13.23,7.23,102.33,102.33,0,1,1,179.63,0A7.53,7.53,0,0,1,366.66,250.17Z" transform="translate(-82.05 -56.12)" /><path d="M477.33,282.47H89.59a7.54,7.54,0,1,1,0-15.08H477.33a7.54,7.54,0,0,1,0,15.08Z" transform="translate(-82.05 -56.12)" /></svg>
          </Link>
          <button
            className={`hyp-navbutton ${visibleSection === "Leadership" ? "hyp-navSelected" : ""}`}
            onClick={() => { scrollTo(landingRef.current); }}
          >
            Landing
          </button>
          <div className="vl" />
          <button
            className={`hyp-navbutton ${visibleSection === "About" ? "hyp-navSelected" : ""}`}
            onClick={() => { scrollTo(aboutRef.current); }}
          >
            About
          </button>
          <div className="vl" />
          <button
            className={`hyp-navbutton ${visibleSection === "Case Design" ? "hyp-navSelected" : ""}`}
            onClick={() => { scrollTo(designRef.current); }}
          >
            Case Design
          </button>
          <div className="vl" />
          <button
            className={`hyp-navbutton ${visibleSection === "Mounting Mechanism" ? "hyp-navSelected" : ""}`}
            onClick={() => { scrollTo(mountRef.current); }}
          >
            Mounting
          </button>
          <div className="vl" />
          <button
            className={`hyp-navbutton ${visibleSection === "PCB" ? "hyp-navSelected" : ""}`}
            onClick={() => { scrollTo(pcbRef.current); }}
          >
            PCB
          </button>
          <div className="vl" />
          <button
            className={`hyp-navbutton ${visibleSection === "Dimensions" ? "hyp-navSelected" : ""}`}
            onClick={() => { scrollTo(dimensionsRef.current); }}
          >
            Dimensions
          </button>
          <div className="vl" />
          <button
            className={`hyp-navbutton ${visibleSection === "Assembly" ? "hyp-navSelected" : ""}`}
            onClick={() => { scrollTo(assemblyRef.current); }}
          >
            Assembly
          </button>
          <div className="vl" />
        </nav>

        <div className="hyp-sections">
          <section className="hyp-about" id="About" ref={aboutRef}>
            <h1 style={{ marginTop: "14vh", }}>About</h1>
            <p style={{  marginTop: "3rem", marginRight: "calc(8vw + 120px)" }}>
              {/* This is it. <br/>
              <br/>
              This is the debut project. <br/>
              <br/>
              After going through at least a hundred of iterations (<i>like actually a hundred</i>), I felt that this 
              project came to a reasonable point enough for me to share what has been going on behind the 
              scenes for over a year.  */}
              Work In Progress
            </p>
          </section>
          <section className="hyp-about" id="Case Design" ref={designRef}>

          </section>
          <section className="hyp-about" id="Mounting Mechanism" ref={mountRef}>

          </section>
          <section className="hyp-about" id="PCB" ref={pcbRef}>

          </section>
          <section className="hyp-about" id="Dimensions" ref={dimensionsRef}>

          </section>
          <section className="hyp-about" id="Assembly" ref={assemblyRef}>

          </section>
        </div>
      </div>
      <FooterDark />
    </div>
  )

}

export default Hyperion
